var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BRAZE } from "../constants/index";
var BrazeSdkService = (function () {
    function BrazeSdkService(siteId, subscriptionGroupId, sdkUrl, sdkKey, enableBrazeSdkLogging) {
        this.defaultLocalData = { token: '', braze_id: '', users: {} };
        this.siteId = siteId;
        this.sdkUrl = sdkUrl;
        this.sdkKey = sdkKey;
        this.enableSdkLogging = enableBrazeSdkLogging;
        this.subscriptionGroupId = subscriptionGroupId;
        this.sdk = window.braze;
        var SUBSCRIPTION_TYPES = BRAZE.SUBSCRIPTION_TYPES, SUBSCRIPTION_STATUS = BRAZE.SUBSCRIPTION_STATUS;
        this.CONSTANTS = {
            SUBSCRIPTION_TYPES: SUBSCRIPTION_TYPES,
            SUBSCRIPTION_STATUS: SUBSCRIPTION_STATUS
        };
    }
    BrazeSdkService.prototype.initialize = function () {
        var options = {
            baseUrl: this.sdkUrl,
            enableLogging: this.enableSdkLogging,
            enableSdkAuthentication: true,
            allowUserSuppliedJavascript: true
        };
        var sdkInit = this.sdk.initialize(this.sdkKey, options);
        return sdkInit;
    };
    BrazeSdkService.prototype.openSession = function () {
        try {
            this.sdk.openSession();
        }
        catch (e) {
            var error = e;
            if (error.message.indexOf('initialized') > -1) {
                if (this.initialize()) {
                    this.sdk.openSession();
                }
            }
            else {
                console.error(error.message);
            }
        }
    };
    BrazeSdkService.prototype.setup = function (email) {
        var _this = this;
        if (this.initialize()) {
            this.sdk.automaticallyShowInAppMessages();
            var changeUserOpenSession = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!email) return [3, 2];
                            return [4, this.changeUser(email)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.openSession();
                            return [2];
                    }
                });
            }); };
            changeUserOpenSession();
            return true;
        }
        return false;
    };
    BrazeSdkService.prototype.logCustomEvent = function (event, data) {
        this.sdk.logCustomEvent(event, data);
    };
    BrazeSdkService.prototype.changeUser = function (external_id) {
        return __awaiter(this, void 0, void 0, function () {
            var authAndCallService, authSuccessful;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!external_id) {
                            return [2, false];
                        }
                        external_id = external_id.toLowerCase();
                        this.setLocalData({ braze_id: external_id });
                        this.sdk.subscribeToSdkAuthenticationFailures(function (error) { return __awaiter(_this, void 0, void 0, function () {
                            var newJwtResponse, newJwt, e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4, this.getAuthToken(external_id, true)];
                                    case 1:
                                        newJwtResponse = _a.sent();
                                        newJwt = newJwtResponse.token;
                                        this.sdk.setSdkAuthenticationSignature(newJwt);
                                        return [3, 3];
                                    case 2:
                                        e_1 = _a.sent();
                                        throw new Error(e_1.message);
                                    case 3: return [2];
                                }
                            });
                        }); });
                        authAndCallService = function () { return __awaiter(_this, void 0, void 0, function () {
                            var authResponse, jwt, e_2;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 3]);
                                        return [4, this.getAuthToken(external_id)];
                                    case 1:
                                        authResponse = _b.sent();
                                        jwt = ((_a = authResponse) === null || _a === void 0 ? void 0 : _a.token) || '';
                                        this.sdk.changeUser(external_id, jwt);
                                        setTimeout(function () {
                                        }, 500);
                                        return [2, true];
                                    case 2:
                                        e_2 = _b.sent();
                                        return [2, false];
                                    case 3: return [2];
                                }
                            });
                        }); };
                        return [4, authAndCallService()];
                    case 1:
                        authSuccessful = _a.sent();
                        return [2, authSuccessful];
                }
            });
        });
    };
    BrazeSdkService.prototype.decodeAuthToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, contentType, tokenObject, e_3, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        url = window.reactSystemData.baseUrl.decodeBrazeToken;
                        return [4, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ token: token })
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        if (!(response.ok && (contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')))) return [3, 3];
                        return [4, response.json()];
                    case 2:
                        tokenObject = _a.sent();
                        return [2, tokenObject];
                    case 3: return [3, 5];
                    case 4:
                        e_3 = _a.sent();
                        error = e_3;
                        console.log(error.message);
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    BrazeSdkService.prototype.callTokenEndpoint = function (external_id) {
        return __awaiter(this, void 0, void 0, function () {
            var authToken, url, response, contentType, error_1, e;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authToken = { token: '' };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        url = window.reactSystemData.baseUrl.getBrazeToken;
                        return [4, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ external_id: external_id })
                            })];
                    case 2:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        if (!(response.ok && (contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')))) return [3, 4];
                        return [4, response.json()];
                    case 3:
                        authToken = _a.sent();
                        _a.label = 4;
                    case 4: return [3, 6];
                    case 5:
                        error_1 = _a.sent();
                        e = error_1;
                        throw new Error(e.message);
                    case 6: return [2, authToken];
                }
            });
        });
    };
    BrazeSdkService.prototype.getAuthToken = function (external_id, force) {
        if (force === void 0) { force = false; }
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var authToken, forceNew, tokenObject, _b, sub, exp, subjectMismatch, expired;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        authToken = (_a = this.getToken()) !== null && _a !== void 0 ? _a : '';
                        forceNew = force || !authToken.token;
                        if (!!forceNew) return [3, 2];
                        return [4, this.decodeAuthToken(authToken.token)];
                    case 1:
                        tokenObject = (_c.sent());
                        if (tokenObject) {
                            _b = tokenObject.payload, sub = _b.sub, exp = _b.exp;
                            subjectMismatch = sub !== external_id;
                            expired = exp ? Date.now() >= exp * 1000 : false;
                            if (subjectMismatch || expired) {
                                forceNew = true;
                            }
                        }
                        else {
                            forceNew = true;
                        }
                        _c.label = 2;
                    case 2:
                        if (!forceNew) return [3, 4];
                        return [4, this.callTokenEndpoint(external_id)];
                    case 3:
                        authToken = _c.sent();
                        if (!authToken) {
                            throw new Error('Unable to create a authentication token at this time.');
                        }
                        this.setLocalData(authToken);
                        _c.label = 4;
                    case 4: return [2, authToken];
                }
            });
        });
    };
    BrazeSdkService.prototype.getToken = function () {
        var token = this.getLocalData().token;
        return { token: token };
    };
    BrazeSdkService.prototype.getLocalData = function () {
        var localStorageData = localStorage.getItem('braze');
        var localDataObject = {};
        if (localStorageData) {
            try {
                localDataObject = JSON.parse(localStorageData);
            }
            catch (e) {
                throw new Error(e);
            }
        }
        return __assign(__assign({}, this.defaultLocalData), localDataObject);
    };
    BrazeSdkService.prototype.setLocalData = function (data) {
        var localData = __assign(__assign({}, this.getLocalData()), data);
        localStorage.setItem('braze', JSON.stringify(localData));
    };
    return BrazeSdkService;
}());
export { BrazeSdkService };
//# sourceMappingURL=BrazeSdkService.js.map